var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "input" },
    [
      _c("textarea", {
        directives: [
          {
            name: "model",
            rawName: "v-model.string",
            value: _vm.inputVal,
            expression: "inputVal",
            modifiers: { string: true }
          }
        ],
        class: _vm.inputClass,
        attrs: { type: "text", placeholder: _vm.placeholder },
        domProps: { value: _vm.inputVal },
        on: {
          blur: function($event) {
            return _vm.handleBlur()
          },
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.inputVal = $event.target.value
          }
        }
      }),
      _vm._v(" "),
      _c("inputAlert", { attrs: { error: _vm.error } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-06ddd4a8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06ddd4a8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/input-textarea.vue
// module id = null
// module chunks = 